// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccountTilesDataModel } from "@guestsupply/App/Services/AccountTilesService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type AccountTilesStateModel = {
    data: AccountTilesDataModel | {};
};

const initialState: AccountTilesStateModel = {
    data: {},
};

const xAccountTilesData = createTypedReducerWithImmer(initialState, {
    "xAccountTiles/CompleteLoadAccountTilesData": (
        draft: Draft<AccountTilesStateModel>,
        action: { accountTilesData: AccountTilesDataModel },
    ) => {
        draft.data = action.accountTilesData!;
    },
});

(reducers as any).xAccountTilesData = xAccountTilesData;

export type xAccountTilesData = {
    xAccountTilesData: AccountTilesStateModel;
} & ApplicationState;

type AccountTilesDataReducer = {
    accountTilesData: typeof xAccountTilesData;
};

export type AccountTilesDataActions = Parameters<AccountTilesDataReducer[keyof AccountTilesDataReducer]>[1] | AnyAction;
